import { render } from "./Pendings.vue?vue&type=template&id=4404b7d2"
import script from "./Pendings.vue?vue&type=script&lang=js"
export * from "./Pendings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__